import React from 'react';
import styled from 'styled-components/macro';
import { components } from 'react-select';
import { ParagraphNormalBold15 } from 'lib/components/styles/typography';
import { MdFolderShared, MdSupervisorAccount } from 'react-icons/md';
import { FOLDER_TYPES } from 'lib/api/folders/getFoldersV2';

export type FolderOption = {
  value: string | number;
  label: string | number;
  sharedBy?: string;
  isSharedFolder?: boolean;
  folderType?: FOLDER_TYPES;
  userId?: number;
};

const Label = styled(ParagraphNormalBold15)`
  color: inherit;
  font-size: 14px;
  line-height: 20px;
  font-weight: 500;
  transition: all 0.3s;
`;

const OptionWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: centre;
  gap: 8px;
`;

export const CustomOption = (props: any) => {
  const isSharedFolder = !!props.data.isSharedFolder;
  const isSharedWithMe = !!props.data.sharedBy?.length;
  const isDefaultFolder = props.data.folderType === FOLDER_TYPES.DEFAULT;

  return (
    <components.Option {...props}>
      <OptionWrapper>
        {(!!isSharedWithMe || !!isDefaultFolder) && (
          <MdSupervisorAccount size={20} style={{ justifyContent: 'center' }} />
        )}
        {!!isSharedFolder && <MdFolderShared size={20} />}

        <Label title={props.label}>{props.label}</Label>
      </OptionWrapper>
    </components.Option>
  );
};
